.as{overflow:hidden;}